import { render } from "./StorefrontHero.vue?vue&type=template&id=7e6b3c45&scoped=true"
import script from "./StorefrontHero.vue?vue&type=script&lang=js"
export * from "./StorefrontHero.vue?vue&type=script&lang=js"

import "./StorefrontHero.vue?vue&type=style&index=0&id=7e6b3c45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e6b3c45"]])

export default __exports__